import { checkObjectMask, GetGoodsClassifierData } from '@shared';

export function getGoodsClassifierDescription(item: GetGoodsClassifierData | string): string {
  if (!item) {
    return '';
  }

  if (typeof item === 'string') {
    return item;
  }

  if (!item.SubCategoryDescription) {
    return item.ProductDescription;
  }

  if (!item.ProductDescription) {
    return item.SubCategoryDescription;
  }

  return `${item.SubCategoryDescription}: ${item.ProductDescription}`;
}

export const goodsClassifierResultKeys = Object.keys({} as GetGoodsClassifierData).map((key) => key as keyof GetGoodsClassifierData);

export const goodsClassifierMaskValidator = checkObjectMask(goodsClassifierResultKeys);

export const descriptionMinLength = 3;
